import React from 'react';
import PropTypes from "prop-types";

import PerPage from './PerPage';

function SimplePaginator({limit, last_item, goNextPage, setLimit}) {
    function renderNextButton() {
        if (last_item) {
            return (
                <li className="page-item">
                    <a className="page-link" href="#" aria-label="Next"
                       onClick={() => goNextPage(last_item)}>
                        <span aria-hidden="true">&raquo;</span>
                        <span className="sr-only">Next</span>
                    </a>
                </li>
            );
        }

        return '';
    }

    return (
        <nav aria-label="Bottom pagination">
            <PerPage limit={limit} setLimit={setLimit}/>
            <ul className="pagination flex-wrap">
                {renderNextButton()}
            </ul>
        </nav>
    );
}

SimplePaginator.propTypes = {
    limit: PropTypes.number.isRequired,
    last_item: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.object,
    ]),
    goNextPage: PropTypes.func.isRequired,
    setLimit: PropTypes.func.isRequired,
};

export default SimplePaginator;
